import axios, { AxiosError } from 'axios';
import { ApiLogin } from '../axiosLogin';

interface IAuth {
  accessToken: string;
}
export interface IUsuarios {
  login: string;
  senha: string;
}
type BackendError = {
  errors?: {
    default?: string;
  };
};
const auth = async (login: string, senha: string): Promise<IAuth | Error> => {
  try {
    const dados = {
      login,
      senha,
    };
    const { data } = await ApiLogin.post<IAuth>('/login', dados);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<BackendError | string>;
      if (axiosError.response?.data) {
        if (typeof axiosError.response.data === 'string') {
          return new Error(axiosError.response.data);
        }
        if (axiosError.response.data.errors?.default) {
          return new Error(axiosError.response.data.errors.default);
        }
        return new Error(JSON.stringify(axiosError.response.data));
      }
      if (axiosError.request) {
        return new Error('Erro de comunicação com o servidor');
      }
      return new Error(axiosError.message);
    }
    if (error instanceof Error) {
      return error;
    }
    return new Error(String(error));
  }
};
export const AuthService = {
  auth,
};
